import React, { useState } from "react";
import "./common.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useData } from "../utils/dataProvider";
export default function GuideLine({}) {
    const location = useLocation();
    const navigate = useNavigate();
    const { page, setPage } = useData();

    return (
        <div className='guideline'>
            <div
                style={{
                    cursor: "pointer",
                }}
                onClick={() => navigate("/")}
                className={`phase-item ${
                    location.pathname == "/" ? "active" : ""
                }`}>
                <div className='phase-item-number'>1</div>
                <div className='phase-item-text'>Fahrzeug</div>
                <div className='line line-1'></div>
            </div>

            <div
                className={`phase-item ${
                    page == 2 && location.pathname.indexOf("model") > 0
                        ? "active"
                        : ""
                }`}
                style={{
                    cursor: location.pathname.indexOf("model") > 0 && "pointer",
                }}
                onClick={() => {
                    if (location.pathname.indexOf("model") > 0) {
                        setPage(2);
                    }
                }}>
                <div className='phase-item-number'>2</div>
                <div className='phase-item-text'>Tarif</div>
                <div className='line line-2'></div>
            </div>

            <div
                className={`phase-item ${
                    page == 3 && location.pathname.indexOf("model") > 0
                        ? "active"
                        : ""
                }`}>
                <div className='phase-item-number'>3</div>
                <div className='phase-item-text'>Ihre Daten</div>
                <div className='line line-3'></div>
            </div>

            <div
                className={`phase-item ${
                    location.pathname.indexOf("finish") > 0 ? "active" : ""
                }`}>
                <div className='phase-item-number'>4</div>
                <div className='phase-item-text'>Angebot</div>
                <div className='line line-4'></div>
            </div>
        </div>
    );
}
